import { RecordPatch, RecordSlot } from '#record/model';
import { utils } from 'apprise-core/utils';
import { authorizationType } from './constants';
import { DeepPartial } from 'apprise-core/utils';

export type AuthorizationPatch = RecordPatch<typeof authorizationType>

export type Authorization = RecordSlot & {


    from: string
    to: string

}

// minimal skeleton for missing slots.
export const newAuthorizationSlot = () => {

    const partials: DeepPartial<Authorization> = {

        id: utils().mint('A'),

    }

    return partials as Authorization
}

export const noAuthorization: Authorization = {
    id: undefined!, timestamp: undefined!,
    from: undefined!, to: undefined!
} 